export const learnMoreLink =
    'https://support.approvalmax.com/portal/kb/articles/accrual-report-csv-for-xero-manual-journal-entry';
